import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    fullLabel: Boolean
  }

  static targets = [
    "country",
    "companyIdentifierInput",
    "companyIdentifierLabel",
    "companyIdentifierHint",
    "vatNumberInput",
    "vatNumberHint"
  ]

  connect() {
    this.handleSelect2Events()
    this.updateCountry()
  }

  async updateCountry() {
    if(!this.hasCountryTarget)
      return;

    const countryData = await this.fetchCountryData()
    this.updateCompanyIdentifier(countryData)
    this.updateVatNumber(countryData)
  }

  async fetchCountryData() {
    try{
      const countryId = this.countryTarget.value
      const response = await fetch(`/countries/${countryId}`)
      return await response.json()
    } catch(error) {
      console.error("Error while fetching country data :", error)
    }
  }

  updateCompanyIdentifier(countryData) {
    if(this.hasCompanyIdentifierLabelTarget) {
      if (this.fullLabelValue) {
        this.companyIdentifierLabelTarget.textContent = countryData.company_identifier.full_label
      } else {
        this.companyIdentifierLabelTarget.textContent = countryData.company_identifier.name
      }
    }

    if(this.hasCompanyIdentifierInputTarget)
      this.companyIdentifierInputTarget.placeholder = countryData.company_identifier.example

    if(this.hasCompanyIdentifierHintTarget)
      this.companyIdentifierHintTarget.textContent = countryData.company_identifier.hint
  }

  updateVatNumber(countryData) {
    if(this.hasVatNumberInputTarget)
      this.vatNumberInputTarget.placeholder = countryData.vat_number.example

    if(this.hasVatNumberHintTarget)
      this.vatNumberHintTarget.textContent = countryData.vat_number.hint
  }

  // Translate Select2 jQuery events into native DOM events
  handleSelect2Events() {
    $(this.element).on("select2:select select2:unselect", function(e) {
      e.target.dispatchEvent(new Event("change", { bubbles: true }))
    })
  }
}
